import { AddEmployeeDto } from '@/core';

export const handleEmployeeData = (employeeData: AddEmployeeDto) => {
  let [unitManager, department] = employeeData.department.split('_');
  if (unitManager === 'department') {
    unitManager = '';
  }
  const handledEmployeeData = {
    ...employeeData,
    department,
    unitManager: unitManager ? unitManager : null,
  };

  return handledEmployeeData;
};
